import React from "react";
import styled from "styled-components";

import Button from "../../../common/Button";
import useTranslate from "../../../hooks/useTranslate";
import { Centered } from "../commonStyles";

const PageLoadError = () => {
  const i18n = useTranslate();

  return (
    <Centered>
      <ErrorText>{i18n("GENERAL.ERROR_OCCURRED_TRY_AGAIN")}</ErrorText>
      <Button variant="outlined" onClick={() => window.location.reload()}>
        {i18n("GENERAL_ACTIONS.REFRESH")}
      </Button>
    </Centered>
  );
};

export default PageLoadError;

const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.fg.secondary};
  ${({ theme }) => theme.typography.subtitle4};
`;
